var include_local_governments = `
<div class="conmbo-notice--none">
	<p class="align-center">
		現在、対象の自治体はありません。
	</p>
</div>
`;
